import src from "IMAGE";
export default { src, width: 2560, height: 730, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAR0lEQVR42hWKMQrAMAgA8xHFsYsQ2qLQoeAiBSm+Jh/Iy2OG44a7JiIXACgiPuW7/BJRd/eRmX9T1bPCZo+9BmHmLyKmmR0LfLkMStWzI7gAAAAASUVORK5CYII="};
